export default __webpack_public_path__ + "static/media/Powder of Life.2330da5d.png";